/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Nav_MoneyInputs */



/**
* | output |
* | --- |
* | "Money" |
*
* @param {Portal_Nav_MoneyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portal_nav_money = /** @type {((inputs?: Portal_Nav_MoneyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Nav_MoneyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Money")
});